<template>
  <div :class="classes"  id="wt-map" class="wt-map">
  </div>
</template>

<script>
// 组件class前缀
import importHttp from '../../../utils/importHttp'
// import api222 from './aaa'
const prefixCls = 'wt-map-tencent'
export default {
  name: 'wt-map-tencent',
  props: {
    cityAddress: {
      type: [Object, String],
      default: function () {
        return {}
      }
    },
    pointCoor: {
      type: [Object, Array],
      default: function () {
        return {
        }
      }
    },
    mapKey: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      timer: '',
      address: {},
      write: ''
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  watch: {
    province (val, old) {
      val = typeof val === 'string' ? JSON.parse(val) : val
      let provinceName = val.province
      let addressAll =
        (val.province ? val.province : '') +
        (val.city ? val.city : '') +
        // (val.district ? val.district : "") +
        val.address
      this.address.province = val.province
      this.address.city = val.city
      this.address.district = val.district
      this.address.address = val.address
      if (old && old.district && val !== old) {
        // 判断是否是第一次进入（如果是第一次进入的话，出入第三个参数为true，读取坐标--this.pointCoor，如果是更改后的位置第三个参数为false，不读取坐标--this.pointCoor）
        this.tengxunMap(addressAll, provinceName, true)
      } else {
        this.tengxunMap(addressAll, provinceName)
      }
      //   handler: function (val, old) {

    //   }
    }
  },
  mounted () {},

  methods: {
    mapInit () {
      if (this.cityAddress.district) {
        let val = this.cityAddress
        var provinceName = val.province
        var addressAll =
                (val.province ? val.province : '') +
                (val.city ? val.city : '') +
                // (val.district ? val.district : "") +
                val.address
        this.tengxunMap(addressAll, provinceName, true)
      } else {
        this.tengxunMap()
      }
    },
    tengxunMap (val, provinceName, isChangCity) {
      /* global qq */
      var geocoder = new qq.maps.Geocoder()
      var center = new qq.maps.LatLng(39.916527, 116.397128)
      var map = new qq.maps.Map('wt-map', {
        center: center,
        zoom: 13
      })
      var info = new qq.maps.InfoWindow({
        map: map
      })
      var marker = new qq.maps.Marker({
        position: center,
        draggable: true,
        map: map
      })
      if (val) {
        let latLngPiont = isChangCity
          ? new qq.maps.LatLng(this.pointCoor.lat, this.pointCoor.lng)
          : null
        geocoder.getLocation(val)
        let vm = this
        marker.setMap(null)
        geocoder.setComplete(function (result) {
          map.setCenter(result.detail.location)
          marker = new qq.maps.Marker({
            map: map,
            draggable: true,
            position: latLngPiont || result.detail.location
          })
          vm.mapDraged(info, marker)
          let coor = [
            result.detail.location.lat,
            result.detail.location.lng
          ]
          vm.$emit('mapToProvince', vm.address, coor)
        })
        // let coor = [marker.getPosition().lat, marker.getPosition().lng];
        this.mapDraged(info, marker)
      }
    },
    mapDraged (info, marker) {
      let vm = this
      qq.maps.event.addListener(marker, 'dragend', function (result) {
        info.setPosition(marker.getPosition())
        let latLng = marker.getPosition()
        vm.getAddress(latLng)
      })
    },
    getAddress (latLng) {
      let vm = this
      var geocoder = new qq.maps.Geocoder()
      geocoder.getAddress(latLng)
      let address = {}
      geocoder.setComplete(function (result) {
        result = result.detail.addressComponents
        address.province = result.province
        address.city = result.city
        address.district = result.district
        address.address = result.streetNumber
        let coor = [latLng.lat, latLng.lng]
        vm.$emit('map-to-province', address, coor)
      })
    },
    interhips (str) {
      let src = str.replace(/.*src=\"([^\"]*)\".*/, '$1')// eslint-disable-line  
      // 取出src的链接
      importHttp(undefined, { src,
        'charset': 'utf-8',
        events: [{ name: 'load',
          handler: _ => {
            this.mapInit()
            document.write = this.write
          } }] })
    }
  },
  created () {
    this.write = document.write
    document.write = this.interhips// 重写document.write
    importHttp(undefined, { src: 'https://map.qq.com/api/js?v=2.exp&key=' + this.mapKey, 'charset': 'utf-8' })
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-map{
    width: 100%;
    height: 100%
}
</style>
